// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__4Wkg4","logoMin":"logo_logoMin__uZlBF"};